import { Component } from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from '../ui/button';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    
    // Log to console in development
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Could send to error tracking service here
    // e.g., Sentry.captureException(error, { extra: errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div className="min-h-screen bg-surface-2 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="w-16 h-16 mx-auto bg-signal-stop-tint rounded-full flex items-center justify-center mb-4">
              <AlertTriangle className="w-8 h-8 text-signal-stop" />
            </div>
            
            <h1 className="text-xl font-bold text-ink mb-2">
              Something went wrong
            </h1>
            
            <p className="text-ink-soft mb-6">
              {this.props.fallbackMessage || 
                "We're sorry, but something unexpected happened. Please try again or return to the home page."}
            </p>
            
            {import.meta.env.DEV && this.state.error && (
              <div className="bg-paper rounded-lg p-4 mb-6 text-left overflow-auto max-h-32">
                <p className="text-xs font-mono text-signal-stop">
                  {this.state.error.toString()}
                </p>
              </div>
            )}
            
            <div className="flex gap-3 justify-center">
              <Button 
                variant="outline" 
                onClick={this.handleGoHome}
                className="gap-2"
              >
                <Home size={16} />
                Go Home
              </Button>
              <Button 
                onClick={this.handleRetry}
                className="gap-2 bg-verlo hover:bg-verlo-hover"
              >
                <RefreshCw size={16} />
                Try Again
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
